import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from 'utils/logger';
import { getEmployeeSchedules } from '../../services';
import { groupEmployeesByTaskType } from '../utils';

export function useTaskAssignment() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const employeesByTaskType = useMemo(() => groupEmployeesByTaskType(data), [data]);

  const fetchEmployees = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getEmployeeSchedules();
      setData(data);
    } catch (error) {
      toast.error(
        logError({
          message: 'Failed to fetch assignable employees',
          error,
          code: 'FAILED_TO_FETCH_ASSIGNABLE_EMPLOYEES',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return { employeesByTaskType, loading, refresh: fetchEmployees };
}
